import React from 'react'
import { IoAlertCircleOutline } from 'react-icons/io5'

// ─────────────────────────────────────────────────────────────────────────────
//  MOLDURA DAS TELAS DE ENTRADA (login e cadastro)
//  Painel escuro da marca à esquerda + formulário à direita, com o mesmo
//  campo. O login e o /cadastro são a mesma experiência visual: quem cria a
//  conta hoje reconhece a tela quando volta amanhã.
// ─────────────────────────────────────────────────────────────────────────────

export function Campo({ id, label, rotuloExtra, dica, erro, icone: Icone, adorno, ...input }) {
    return (
        <div className={'onb-field' + (erro ? ' invalid' : '')}>
            {rotuloExtra
                ? <div className="onb-label-row"><label className="onb-label" htmlFor={id}>{label}</label>{rotuloExtra}</div>
                : <label className="onb-label" htmlFor={id}>{label}</label>}
            <div className="onb-input-wrap">
                {Icone && <Icone className="onb-input-icon" size={18} />}
                <input id={id} className={'onb-input' + (Icone ? ' has-icon' : '') + (adorno ? ' has-adorn' : '')}
                    aria-invalid={!!erro} aria-describedby={erro ? id + '-erro' : undefined} {...input} />
                {adorno && <span className="onb-adorn">{adorno}</span>}
            </div>
            {erro
                ? <span className="onb-field-error" id={id + '-erro'}><IoAlertCircleOutline size={15} />{erro}</span>
                : dica && <span className="onb-hint">{dica}</span>}
        </div>
    )
}

// ── Painel da marca (desktop) ────────────────────────────────────────────────
// Mesma moldura no login e no cadastro; muda só o que ela lista: no cadastro,
// o caminho em 4 passos; no login, o que a BIWAPP faz pela loja.
export function PainelMarca({ texto, itens, automatico = false, pulso = false }) {
    return (
        <aside className="cad-brand">
            <div className="login-backdrop" aria-hidden="true">
                <div className="login-aurora login-aurora-1" />
                <div className="login-aurora login-aurora-2" />
                <div className="login-aurora login-aurora-3" />
                <div className="login-grid-overlay" />
            </div>
            {/* no celular o selo da Meta aparece aqui, na mesma linha do logo */}
            <div className="cad-brand-head">
                <img className="cad-brand-logo" src="/images/biwapp-logo-white.svg" alt="BIWAPP" />
                <img className="cad-brand-meta" src="/images/meta-tech-provider-white.png" alt="Meta Tech Provider" />
            </div>
            <div className="cad-pitch">
                <h1>Sua loja no <span>WhatsApp oficial</span>, trabalhando por você.</h1>
                <p>{texto}</p>
                <ol className={'cad-timeline' + (automatico ? ' auto' : '') + (pulso ? ' pulso' : '')}>
                    {itens.map((p) => (
                        <li key={p.titulo} className={p.agora ? 'now' : ''}>
                            <span className="cad-timeline-dot"><p.icone size={18} /></span>
                            <div>
                                <strong>{p.titulo}</strong>
                                <span>{p.texto}</span>
                            </div>
                        </li>
                    ))}
                </ol>
            </div>
            <div className="cad-trust">
                <img src="/images/meta-tech-provider-white.png" alt="Meta Tech Provider" />
                <span className="cad-trust-sep" />
                <span><strong style={{ color: '#fff' }}>200+</strong> negócios usam a BIWAPP</span>
            </div>
        </aside>
    )
}
